import {Directive, HostListener, Input} from '@angular/core';
import {windowOpen} from '../utils/window-utils';

@Directive({
    selector: 'a[target="_blank"]',
    host: {
        '[attr.href]': 'href',
    },
    standalone: true
})
export class TargetBlankDirective {
    @Input() href: string;

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent): void {
        event.preventDefault();
        // demando alla funzione windowOpen di gestire l'apertura del link
        windowOpen(this.href, '_blank');
    }
}
